// Events
import { BFCM_CLOCK_NEWSLETTER_SECTION_READY, BFCM_TEXT_VIDEO_STYLES_UPDATE } from 'events';
import { component } from 'picoapp';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';

export default component(async (node, ctx) => {
  const { picture, pictureWrapper, video, videoWrapper, videoPlay, videoPoster, text } =
    choozy(node);
  const section = node.closest('section');

  const animate = () => {
    const { offsetWidth: pictureWidth } = picture;
    const { offsetWidth: videoWidth } = video;

    disablePageScroll();

    text.removeAttribute('open');

    window.scrollTo({
      top: videoWrapper.offsetTop + section.offsetTop - (window.height - videoWrapper.offsetHeight),
      left: 0,
      behavior: 'instant',
    });

    picture.style.transform = `scale(${videoWidth / pictureWidth})`;

    setTimeout(() => {
      node.setAttribute('open', '');

      window.scrollTo({
        top:
          videoWrapper.offsetTop + section.offsetTop - (window.height - videoWrapper.offsetHeight),
        left: 0,
        behavior: 'instant',
      });

      setTimeout(() => {
        setCSSProperty(document.documentElement, '--bfcm-clock-newsletter-offset', '');
        setCSSProperty(document.documentElement, '--bfcm-text-video-picture-offset', '');

        pictureWrapper.removeAttribute('open');
        videoPlay.setAttribute('open', '');

        window.scrollTo({
          top: section.offsetTop - (window.height - videoWrapper.offsetHeight),
          left: 0,
          behavior: 'instant',
        });

        enablePageScroll();
      }, 1000);
    }, 1000);
  };

  const getNextSiblings = (targetElement) => {
    const siblings = [];
    let elem = targetElement;

    while (elem.nextElementSibling) {
      siblings.push(elem.nextElementSibling);
      elem = elem.nextElementSibling;
    }

    return siblings;
  };

  if (picture && video) {
    const sectionsWrapper = document.createElement('div');
    const siblingSections = getNextSiblings(section);
    const { pictureAspect } = picture.dataset;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target === video) {
            animate();
            observer.unobserve(video);
          }
        });
      },
      { threshold: 1 },
    );

    ctx.on(BFCM_CLOCK_NEWSLETTER_SECTION_READY, () => {
      picture.setAttribute('open', '');
      ctx.emit(BFCM_TEXT_VIDEO_STYLES_UPDATE, {}, pictureAspect);
    });
    observer.observe(video);

    section.insertAdjacentElement('afterend', sectionsWrapper);
    siblingSections.forEach((siblingSection) => {
      sectionsWrapper.insertAdjacentElement('beforeend', siblingSection);
    });
    sectionsWrapper.classList.add(
      'sticky',
      'bottom-[var(--sections-offset-mobile)]',
      'bottom-[var(--sections-offset)]',
    );
    document.documentElement.style.setProperty(
      '--sections-offset-mobile',
      `-${sectionsWrapper.offsetHeight - window.innerHeight + video.offsetHeight}px`,
    );
    document.documentElement.style.setProperty(
      '--sections-offset',
      `-${sectionsWrapper.offsetHeight - window.innerHeight + 200}px`,
    );
  }

  if (video && videoPlay) {
    videoPlay?.addEventListener('click', () => {
      videoPlay.removeAttribute('open');
      videoPoster.removeAttribute('open');
      video.setAttribute('controls', '');
      video.play();
    });
  }
});
